import React, { useState } from 'react';
import CommonSeoContent from "../components/CommonSeoContent";
import "../AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-container">
      <h1 className="about-title">About Us</h1>
      <p className="about-text">
        Welcome to <span className="highlight">jsonconverter.org</span>,
        a simple and powerful online tool for formatting and converting data.
      </p>

      <p className="about-text">
        We created this platform to make working with data easier, whether you’re
        a developer, data analyst, or just someone handling structured files.
        Our tools help you quickly format, beautify, and convert between different
        formats such as <strong>JSON, CSV, XML, and YAML</strong>.
      </p>

      <h2 className="about-subtitle">What We Offer:</h2>
      <ul className="about-list">
        <li>✨ <strong>Formatters</strong> – Validate, Beautify or minify JSON, XML, and YAML with a single click.</li>
        <li>🔄 <strong>Converters</strong> – Convert data between JSON, XML, CSV, and YAML instantly.</li>
        <li>💻 <strong>Code Generators</strong> – Convert JSON into multiple programming languages (Java, C, C++, C#,  Python, PHP, etc.).</li>
        <li>⚡ <strong>User-Friendly</strong> – No installations. Just paste, upload, or type your data and get results immediately.</li>
      </ul>

      <h2 className="about-subtitle">Our Mission</h2>
      <p className="about-text">
        Our mission is to provide developers and data professionals with
        <strong> fast, reliable, and easy-to-use tools </strong> that simplify everyday tasks.
        We believe that working with data should be efficient, secure, and hassle-free.
      </p>

      <h2 className="about-subtitle">Why Choose Us?</h2>
      <ul className="about-list">
        <li>✅ Free and easy-to-use tools</li>
        <li>✅ Works directly in your browser</li>
        <li>✅ Secure – no data is stored on our servers</li>
        <li>✅ Saves time and boosts productivity</li>
      </ul>

    </div>
  );
};

export default AboutUs;
